import { createAxios, createAxiosHeaders } from "./axiosHttpMarconi";

export const whatsappService = {
  getWhatsappChats,
  getWhatsappChatsByEntityId,
  getWhatsappChatById,
  getWhatsappWebhookLogById,
  getWhatsappSendLogById,
  getWhatsappResumen,
  getWhatsappChatsAsExcel,
};

function getWhatsappChats(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/whatsapp`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0&limit=20";
  }

  urlPath += getFilters(filters);
  return axios.get(urlPath);
}

function getWhatsappChatsByEntityId(entityId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/whatsapp/entity/${entityId}`;
  return axios.get(urlPath);
}

function getWhatsappChatById(id) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/whatsapp/${id}`;
  return axios.get(urlPath);
}

function getWhatsappWebhookLogById(logId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/whatsapp/webhook-log/${logId}`;
  return axios.get(urlPath);
}

function getWhatsappSendLogById(logId) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/whatsapp/send-log/${logId}`;
  return axios.get(urlPath);
}

function getWhatsappResumen(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/whatsapp/resumen`;

  if (filters && filters.fecha) {
    urlPath += `?fecha_inicio=${filters.fecha[0]}`;
    urlPath += `&fecha_fin=${filters.fecha[1]}`;
  }

  return axios.get(urlPath);
}

function getWhatsappChatsAsExcel(filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  const urlPath = `/franquiciadora/${user.extraData.franquiciadoraId}/whatsapp/excel?limit=2000${getFilters(
    filters
  )}`;

  return axios
    .get(urlPath, {
      responseType: "blob",
    })
    .catch(async (error) => {
      const data = await error.text();
      throw JSON.parse(data);
    });
}

function getFilters(filters) {
  let urlPath = "";

  if (filters && filters.fecha_inicio) {
    urlPath += `&fecha_inicio=${filters.fecha_inicio}`;
  }

  if (filters && filters.fecha_fin) {
    urlPath += `&fecha_fin=${filters.fecha_fin}`;
  }

  if (filters && filters.entityId) {
    urlPath += `&entityId=${encodeURIComponent(filters.entityId)}`;
  }

  if (filters && filters.tipo) {
    urlPath += `&tipo=${encodeURIComponent(filters.tipo)}`;
  }
  if (filters && filters.origen) {
    urlPath += `&origen=${encodeURIComponent(filters.origen)}`;
  }
  if (filters && filters.numero) {
    urlPath += `&numero=${encodeURIComponent(filters.numero)}`;
  }

  if (filters && filters.templateId) {
    urlPath += `&templateId=${encodeURIComponent(filters.templateId)}`;
  }

  if (filters && filters.franquiciaId) {
    urlPath += `&franquiciaId=${encodeURIComponent(filters.franquiciaId)}`;
  }

  if (filters && filters.numero) {
    urlPath += `&numero=${encodeURIComponent(filters.numero)}`;
  }

  if (filters && filters.estados && filters.estados.length > 0) {
    urlPath += `&estados=${filters.estados.join()}`;
  }

  if (
    filters &&
    Object.prototype.hasOwnProperty.call(filters, "permiteRespuesta")
  ) {
    urlPath += `&permiteRespuesta=${filters.permiteRespuesta}`;
  }

  return urlPath;
}
